import styled from "styled-components"

export const SearchOptionStyle = styled.div`
    display: flex;
    gap: 15px;
    ::v-deep .ant-select {
        margin-left: 0 !important;
    }
`